import React, { useState, useEffect } from "react";
import styles from "./PricingWrapper.module.scss";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import HasPermissionTo from "../../../common/HasPermissionTo";
import SubNavDropdown from "../../../shared/subnav/SubNavDropdown";
import PendingActionClient from "../../../shared/clients/PendingActionClient";
import { ACCESSORIES_VERSION } from "../../../common/Constants";
import Grid from "@mui/material/Grid";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

function PricingWrapper(props) {
  const [showAccessories, setShowAccessories] = useState(props.user.hasNscCompletedBasicPAs);
  const [renderApp, setRenderApp] = useState(false);

  useEffect(() => {
    showAccessoriesCheck();
  }, []);

  function showAccessoriesCheck() {
    if (
      !props.isNsc &&
      ACCESSORIES_VERSION[props.user.market] === 3
    ) {
      PendingActionClient.getHasNscCompletedPA(props.user, 3).then(
        (response) => {
          setShowAccessories(response);
          setRenderApp(true);
        }
      );
    } else {
      setRenderApp(true);
    }
  }

  return (
    renderApp && (
      <div className="pageWrapper" id="PricingWrapper">
        <div className={`${styles.titleDiv} pagePadding`}>
          <div className="pageTitle">
            {props.t("PricingWrapper.title")}
          </div>
          <HasPermissionTo
            perform={["AllCMA:view"]}
            permissions={props.user.permissions.rolePermissions}
            condition={
              !props.restrictDropdown &&
              props.user.dealerGroup &&
              props.user.dealerGroup.length > 1
            }
            render={() => <SubNavDropdown {...props} />}
          />
        </div>
        <p className={`${styles.subHeader} pagePadding`}>
          {props.t("PricingWrapper.subTitle")}
        </p>

        <Grid container spacing={24} className={styles.pricing}>
          <HasPermissionTo
            perform={["depositPricingTab"]}
            permissions={props.user.permissions.rolePermissions}
            render={() => (
              <DisplayPricingType
                goToPage={props.t("PricingWrapper.goToPage")}
                header={props.t("PricingWrapper.deposit")}
                desc={props.t("ALDPricing.subheader")}
                link="/pricing/deposit"
                name="deposit"
              />
            )}
          />
          <HasPermissionTo
            perform={["dealerInventoryDeposit:view"]}
            permissions={props.user.permissions.rolePermissions}
            render={() => (
              <DisplayPricingType
                goToPage={props.t("PricingWrapper.goToPage")}
                header={props.t("PricingWrapper.dealerDeposit")}
                desc={props.t("PricingWrapper.dealerDepositSubheader")}
                link="/pricing/dealerpricing"
                name="deposit"
              />
            )}
          />
          <HasPermissionTo
            perform={["accessoriesPricingTab"]}
            permissions={props.user.permissions.rolePermissions}
            condition={showAccessories}
            render={() => (
              <DisplayPricingType
                header={props.t("PricingWrapper.accessoriesPricing")}
                desc={props.t("PricingWrapper.accessoriesPricingDesc")}
                goToPage={props.t("PricingWrapper.goToPage")}
                link="/pricing/accessories"
                name="accessories"
              />
            )}
          />
        </Grid>
      </div>
    )
  );
}

function DisplayPricingType(props) {
  return (
    <Grid item md={4} xs={6}>
      <div className={styles.priceType}>
        <div>
          <div className={styles.priceTitle}>{props.header}</div>
          <div className={styles.pricingText}>
            {props.desc ? props.desc : "--"}
          </div>
          <Link
            className={styles.link}
            data-testid={props.name}
            to={props.link}
            name={props.name}
          >
            <div className={styles.pageBottom}>
              {props.goToPage}
              <ChevronRightIcon className={styles.rightChevron} />
            </div>
          </Link>
        </div>
      </div>
    </Grid>
  );
}

export default withTranslation("emp")(PricingWrapper);
